import { FC, PropsWithChildren, useState } from 'react';

import { Button, RyeconCaretDown, RyeconCaretRight, Sizes } from '@dbt-labs/sourdough';

export interface FilterSectionProps extends PropsWithChildren<{}> {
  title?: string;
  enableExpansion?: boolean;
  isDefaultExpanded?: boolean;
}

export const FilterSection: FC<FilterSectionProps> = ({
  title,
  children,
  enableExpansion = false,
  isDefaultExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);

  return (
    <div className="my-6">
      <span className="flex items-center">
        <h3>{title}</h3>
        {enableExpansion && (
          <Button
            type="icon-button"
            size={Sizes.sm}
            ryecon={isExpanded ? RyeconCaretDown : RyeconCaretRight}
            onClick={() => setIsExpanded((current) => !current)}
          />
        )}
      </span>
      <div>{(!enableExpansion || (enableExpansion && isExpanded)) && children}</div>
    </div>
  );
};
